export const formatAmount = (amount) => {
    try {
        return Math.ceil(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    } catch (error) {
        return 'ERR'
    }
}